import { render } from "./UniPickerTransition.vue?vue&type=template&id=956fbbfc&scoped=true&ts=true"
import script from "./UniPickerTransition.vue?vue&type=script&lang=ts"
export * from "./UniPickerTransition.vue?vue&type=script&lang=ts"

import "./UniPickerTransition.vue?vue&type=style&index=0&id=956fbbfc&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-956fbbfc"]])

export default __exports__